import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <span className="Footer">
      <a
        href="https://github.com/gmgercke/weather-app-react"
        target="_blank"
        rel="noreferrer"
      >
        Open-source code{" "}
      </a>
      by Gesa-Maria Gercke
    </span>
  );
}
